import React from 'react';
import { colors, fonts } from '../../styles/tokens';

/**
 * Reusable section heading block.
 * label    → small uppercase label above heading
 * heading  → main h2
 * subheading → optional paragraph below
 * labelColor → defaults to red
 * dark     → white text for dark backgrounds
 */
function SectionHeader({ label, heading, subheading, labelColor, dark = false, maxWidth = 520 }) {
  const lColor = labelColor || colors.red;
  const headingColor = dark ? '#fff' : colors.text;
  const subColor = dark ? 'rgba(255,255,255,0.55)' : colors.grayLight;

  return (
    <div style={{ textAlign: 'center', marginBottom: 56 }}>
      {label && (
        <span
          style={{
            fontFamily: fonts.body,
            fontSize: 12,
            fontWeight: 700,
            color: lColor,
            letterSpacing: 3,
            textTransform: 'uppercase',
            display: 'block',
            marginBottom: 10,
          }}
        >
          {label}
        </span>
      )}
      <h2
        style={{
          fontFamily: fonts.display,
          fontSize: 'clamp(26px, 4vw, 40px)',
          fontWeight: 800,
          color: headingColor,
          margin: subheading ? '0 0 14px' : '0',
          lineHeight: 1.2,
        }}
      >
        {heading}
      </h2>
      {subheading && (
        <p
          style={{
            fontFamily: fonts.body,
            fontSize: 16,
            color: subColor,
            maxWidth,
            margin: '0 auto',
            lineHeight: 1.65,
          }}
        >
          {subheading}
        </p>
      )}
    </div>
  );
}

export default SectionHeader;
